import { DetailedInsight } from '@api/api/insights';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQueries, useQuery } from '@tanstack/react-query';
import { getInsight } from '@terminal/services/insights/insights-service';

export const QUERY_KEY_INSIGHT = 'QUERY_KEY_INSIGHT';

export const useInsight = (insightId: string) =>
  useQuery({
    queryKey: [QUERY_KEY_INSIGHT, insightId],
    queryFn: () => getInsight(insightId),
    enabled: !!insightId,
    staleTime: getTimeTillEndOfDayMs(),
  });

export const useQueryInsights = (insightsId: string[], enabled = true) => {
  const queries = insightsId.map(insightId => ({
    queryKey: [QUERY_KEY_INSIGHT, insightId],
    queryFn: () => getInsight(insightId),
    enabled,
    staleTime: getTimeTillEndOfDayMs(),
  }));
  return useQueries({
    queries,
    combine: results => {
      const hasResult = !!results.length;
      return {
        data: results
          .map(result => result.data?.data)
          .filter(Boolean) as DetailedInsight[],
        isFetching:
          hasResult &&
          results.some(result => result.isFetching || result.isRefetching),
        isError: hasResult && results.every(result => result.data?.error),
        refetch: () => {
          results.forEach(result => result.refetch());
        },
      };
    },
  });
};
